import React from "react";

const Controls = ({ children }) => {
	return <>{children}</>;
};

export default Controls;
